import React from "react";
import { ToastContainer } from "react-toastify";

import SettingsHoldsDetails from "./components/SettingsHoldsDetails";

const SettingsHoldsDetailsApp = (props) => {
  return (
    <>
      <ToastContainer icon={false} />
      <SettingsHoldsDetails {...props} />
    </>
  );
};

export default SettingsHoldsDetailsApp;
